import React, { FC } from 'react';

import TicketsTable from 'pages/Tickets/components/TicketsList/components/TicketsTable';
import TicketsPaginationRounded from './components/TicketsPaginationRounded/TicketsPaginationRounded';
import TicketsSearch from './components/TicketsSearch/TicketsSearch';

import useStyles from './styles';
import TicketsFilters from './components/TicketsFilters/TicketsFilters';
import { Grid } from '@mui/material';

const Tickets: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.tickets}>
       <Grid container spacing={2} alignItems="flex-start">
         <Grid item xs={2}>
           <TicketsFilters />
         </Grid>
         <Grid item xs={10}>
           <TicketsSearch />
         </Grid>
       </Grid>
      <div className={classes.ticketsTable}>
        <TicketsTable />
      </div>
      <div className={classes.ticketsPagination}>
        <TicketsPaginationRounded />
      </div>
    </div>
  );
};

export default Tickets;
